import {
  Box,
  IconButton,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Button,
  Typography,
  Tooltip,
  LinearProgress,
  // MenuItem,
} from "@mui/material";
import { useRef, useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import {
  // deleteDiscourseInDatabase,
  updateDiscourse,
  // getDiscourse,
  // addDiscourse,
  getDiscourseTypes,addDiscourseType,deleteDiscourseType
  // getOrphanedWebpMetadata
} from "../../../services/database/database_service";
import DeleteIcon from "@mui/icons-material/Delete";
import areArraysEqual from "../../../utils/are_arrays_equal";
import { AppwriteException } from "appwrite";
import ProgressIndicator from "../../../common/widget/progress_indicator";
import CustomAlert from "../../../common/widget/custom_alert";
import { formatDate } from "../../../utils/format_date";

const DiscourseType = () => {
  const [rows, setRows] = useState([]);
  const [rowsToUpdate, setRowsToUpdate] = useState([]);

  const rowsBackup = useRef([]);
  const [showSaveBtn, setShowSaveBtn] = useState(false);
  const [alert, setAlert] = useState({
    show: false,
    severity: "info",
    msg: "",
  });


  const [discourse, setDiscourse] = useState({
    discourseTypeName: "",
  });

  const [isLoadingData, setIsLoadingData] = useState(false);
  const [showProgressIndicator, setShowProgressIndicator] = useState(false);


  // delete dialog box
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [rowToDelete, setRowToDelete] = useState(null);

  const columns = [
    {
      field: "$createdAt",
      headerName: "Created At",
      headerClassName: "super-app-theme--header",
      flex: 0.5,
      renderHeader: (params) => <strong>Created At</strong>,
      renderCell: (params) => {
        return formatDate(params.value);
      },
    },
    // discourse type
    {
      field: "discourseTypeName",
      headerName: "Discourse Type",
      headerClassName: "super-app-theme--header",
      flex: 1,
      editable: false,
      renderHeader: (params) => <strong>Discourse Type</strong>,
      renderCell: (params) => (
        <Box
          sx={{
            textOverflow: "ellipsis",
            overflow: "auto",
            whiteSpace: "normal",
          }}
        >
          <Typography>{params.row.discourseTypeName}</Typography>
        </Box>
      ),
    },

    // Delete
    {
      field: "delete",
      headerName: "Delete",
      headerClassName: "super-app-theme--header",
      flex: 0.5,
      renderCell: (params) => (
        <Tooltip title="Delete from database">
          <IconButton
            aria-label="delete"
            size="small"
            onClick={() => {
              setRowToDelete(params);
              setDeleteDialogOpen(true);
            }}
          >
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      ),
      renderHeader: (params) => <strong>Delete</strong>,
    },
  ];


  const fetchDiscourseTypes = async () => {
    setRows([]);
    setIsLoadingData(true);
    setAlert({ ...alert, show: false });
    await getDiscourseTypes().then(
      (response) => {
        setRows(response.documents);
        rowsBackup.current = response.documents;
        if (response.total === 0) {
          setAlert({
            show: true,
            severity: "info",
            msg: "No content(s) found",
          });
        }
      },
      (error) => {
        setAlert({
          show: true,
          severity: "error",
          msg: error.response?.message ?? "Could not fetch discourse types. Please try again later.",
        });
      }
    );
    setIsLoadingData(false);
  };

  const handleAddDiscourseType = async () => {
    if (
      !discourse.discourseTypeName.trim() 
    ) {
      setAlert({
        show: true,
        severity: "warning",
        msg: "Please enter a discourse type",
      });
      return;
    }
    setShowProgressIndicator(true);
    setAlert({ ...alert, show: false });

    try {
      await addDiscourseType(discourse); 

      await new Promise((resolve) => setTimeout(resolve, 1000));
      setShowProgressIndicator(false);

      await fetchDiscourseTypes();
      setAlert({
        show: true,
        severity: "success",
        msg: `Discourse type "${discourse.discourseTypeName}" added successfully`,
      });
    } catch (error) {
      await new Promise((resolve) => setTimeout(resolve, 1000));
      setShowProgressIndicator(false);
      setAlert({
        show: true,
        severity: "error",
        msg: `${error.message}`,
      });
    }
  };

  const handleDelete = async (params) => {
    setShowProgressIndicator(true);
    setAlert({ ...alert, show: false });

    deleteDiscourseType(params.row).then(
      async (response) => {
        if (response instanceof AppwriteException) {
          setAlert({
            show: true,
            severity: "error",
            msg: response.response.message,
          });
        } else {
          await new Promise((resolve) => setTimeout(resolve, 1000));
          removeSingleRow(params.row);
          setAlert({
            show: true,
            severity: "success",
            msg: response.message
            //"Discourse type deleted successfully",
          });
        }

        setShowProgressIndicator(false);
      },
      (error) => {
        setAlert({ show: true, severity: "error", msg: error });
      }
    );
  };

  const removeSingleRow = (params) => {
    const newRows = rows.filter(
      (row) => row.discourseTypeName !== params.discourseTypeName
    );
    setRows(newRows);
  };

  function onCellEditStop(params, event) {
    if (event?.target?.value) {
      const newRow = { ...params.row, [params.field]: event.target.value };
      let exist = false;
      let tmpRowsToUpdate = [...rowsToUpdate];
      let count = 0;
      // check if it exists in rowsToUpdate
      for (let r of rowsToUpdate) {
        if (params.id === r.$id) {
          exist = true;
          tmpRowsToUpdate[count] = newRow;
          setRowsToUpdate(tmpRowsToUpdate);
          setShowSaveBtn(true);
          break;
        }
        count++;
      }
      // if doesn't exist then append to list
      if (!exist) {
        tmpRowsToUpdate.push(newRow);
        setRowsToUpdate(tmpRowsToUpdate);
        setShowSaveBtn(true);
      }
    }
  }

  function CustomLinearProgress() {
    return (
      <LinearProgress
        style={{ backgroundColor: "white" }} // Change the background color to purple
        color="secondary" // Change the color to secondary (the color you want)
      />
    );
  }

  useEffect(() => {
    const result = areArraysEqual(rowsBackup.current, rows);
    if (!result) {
      setShowSaveBtn(true);
    } else {
      setShowSaveBtn(false);
    }
  }, [rows, rowsBackup]);

  useEffect(() => {
    fetchDiscourseTypes();
  }, []);


  return (
    <Box p={3} width={"100%"}>
      {/* alert */}
      <CustomAlert alert={alert} setAlert={setAlert} />

      {/* top buttons */}
      <Box sx={{ display: "flex" }} gap={1}>
        <TextField
          size="small"
          label="Add Discourse Type"
          onChange={(e) => setDiscourse({ discourseTypeName: e.target.value })}
        />
        <Button
          variant="outlined"
          onClick={handleAddDiscourseType}
          sx={{ boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)" }}
        >
          Add
        </Button>
      </Box>

      <Typography sx={{ marginTop: 1, marginBottom: 1 }}>
        Total: {rows.length}
      </Typography>

      {/* data grid */}
      <Box
        sx={{
          height: "70vh",
          width: "100%",
          boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
          "& .super-app-theme--header": {
            backgroundColor: "#ebdcfa",
          },
        }}
      >
        <DataGrid
          getRowId={(row) => row.$id}
          rows={rows}
          columns={columns}
          loading={isLoadingData}
          slots={{
            loadingOverlay: CustomLinearProgress,
          }}
          onCellEditStop={onCellEditStop}
        />
      </Box>

      {/* delete dialog */}
      <Dialog
        open={deleteDialogOpen}
        onClose={() => setDeleteDialogOpen(false)}
        aria-labelledby="confirm-delete-data"
      >
        <DialogTitle id="confirm-delete-data">Confirm Deletion</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete the discourse type: "
            <strong>{rowToDelete?.row?.discourseTypeName}</strong>" ? <br/>
            All the discourse data under this will also be deleted.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteDialogOpen(false)} 
            color="primary"
            variant="outlined"
            sx={{ boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)", mb:1 }}
            >
            Cancel
          </Button>
          <Button
            onClick={() => {
              setDeleteDialogOpen(false);
              handleDelete(rowToDelete);
            }}
            variant="outlined"
            sx={{ boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)", mb:1 }}
            color="error"
            autoFocus
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      {/* process indicator */}
      <ProgressIndicator show={showProgressIndicator} />
    </Box>
  );
};
export default DiscourseType;



// // // With dialog box for adding new discourse type
// import {
//   Box,
//   IconButton,
//   TextField,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   DialogContentText,
//   Button,
//   Typography,
//   Tooltip,
//   LinearProgress,
//   // MenuItem,
// } from "@mui/material";
// import { useRef, useState, useEffect } from "react";
// import { DataGrid } from "@mui/x-data-grid";
// import {
//   // deleteDiscourseInDatabase,
//   updateDiscourse,
//   // getDiscourse,
//   // addDiscourse,
//   getDiscourseTypes,addDiscourseType,deleteDiscourseType
//   // getOrphanedWebpMetadata
// } from "../../../services/database/database_service";
// import DeleteIcon from "@mui/icons-material/Delete";
// import areArraysEqual from "../../../utils/are_arrays_equal";
// import { AppwriteException } from "appwrite";
// import ProgressIndicator from "../../../common/widget/progress_indicator";
// import CustomAlert from "../../../common/widget/custom_alert";
// import { formatDate } from "../../../utils/format_date";

// const DiscourseType = () => {
//   const [rows, setRows] = useState([]);
//   const [rowsToUpdate, setRowsToUpdate] = useState([]);
//   // const [selectedRow, setSelectedRow] = useState({});
//   const rowsBackup = useRef([]);
//   const [showSaveBtn, setShowSaveBtn] = useState(false);
//   const [alert, setAlert] = useState({
//     show: false,
//     severity: "info",
//     msg: "",
//   });

//   const [alert2, setAlert2] = useState({
//     show: false,
//     severity: "info",
//     msg: "",
//   });
//   const [openDialog, setOpenDialog] = useState(false);
//   const [discourse, setDiscourse] = useState({
//     discourseTypeName: "",
//     discourseTypeNameDz: "",
//   });

//   const [isLoadingData, setIsLoadingData] = useState(false);
//   const [showProgressIndicator, setShowProgressIndicator] = useState(false);
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   // delete dialog box
//   const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
//   const [rowToDelete, setRowToDelete] = useState(null);

//   const columns = [
//     {
//       field: "$createdAt",
//       //   headerName: "Created At",
//       headerClassName: "super-app-theme--header",
//       flex: 0.5,
//       renderHeader: (params) => <strong>Created At</strong>,
//       renderCell: (params) => {
//         return formatDate(params.value);
//       },
//     },
//     // discourse type en
//     {
//       field: "discourseTypeName",
//       headerName: "Discourse Type",
//       headerClassName: "super-app-theme--header",
//       flex: 1,
//       editable: false,
//       renderHeader: (params) => <strong>English Title</strong>,
//       renderCell: (params) => (
//         <Box
//           sx={{
//             textOverflow: "ellipsis",
//             overflow: "auto",
//             whiteSpace: "normal",
//           }}
//         >
//           <Typography>{params.row.discourseTypeName}</Typography>
//         </Box>
//       ),
//     },

//       // discourse type dz
//     {
//       field: "discourseTypeNameDz",
//       headerName: "Discourse Type",
//       headerClassName: "super-app-theme--header",
//       flex: 1,
//       editable: false,
//       renderHeader: (params) => <strong>Dzongkha Title</strong>,
//       renderCell: (params) => (
//         <Box
//           sx={{
//             textOverflow: "ellipsis",
//             overflow: "auto",
//             whiteSpace: "normal",
//           }}
//         >
//           <Typography>{params.row.discourseTypeNameDz}</Typography>
//         </Box>
//       ),
//     },
//     // Delete
//     {
//       field: "delete",
//       headerName: "Delete",
//       headerClassName: "super-app-theme--header",
//       flex: 0.5,
//       renderCell: (params) => (
//         <Tooltip title="Delete from database">
//           <IconButton
//             aria-label="delete"
//             size="small"
//             onClick={() => {
//               setRowToDelete(params);
//               setDeleteDialogOpen(true);
//             }}
//           >
//             <DeleteIcon />
//           </IconButton>
//         </Tooltip>
//       ),
//       renderHeader: (params) => <strong>Delete</strong>,
//     },
//   ];

//   const handleChange = (e) => {
//     setDiscourse({
//       ...discourse,
//       [e.target.name]: e.target.value,
//     });
//   };

//   const fetchDiscourseTypes = async () => {
//     setRows([]);
//     setIsLoadingData(true);
//     setAlert({ ...alert, show: false });
//     await getDiscourseTypes().then(
//       (response) => {
//         setRows(response.documents);
//         rowsBackup.current = response.documents;
//         if (response.total === 0) {
//           setAlert({
//             show: true,
//             severity: "info",
//             msg: "No content(s) found",
//           });
//         }
//       },
//       (error) => {
//         setAlert({
//           show: true,
//           severity: "error",
//           msg: error.response?.message ?? "Could not fetch discourse types. Please try again later.",
//         });
//       }
//     );


//     // await getDiscourseTypes().then(
//     //   (response) => {
//     //     console.log("Discourse Types: ", response.documents);
//     //     // You can use the response to populate a dropdown or for other purposes
//     //   }
//     // );
//     setIsLoadingData(false);
//   };

//   const handleAddDiscourseType = async () => {
//     if (
//       !discourse.discourseTypeName.trim() ||
//       !discourse.discourseTypeNameDz.trim() 
//     ) {
//       setAlert2({
//         show: true,
//         severity: "warning",
//         msg: "All fields are required!",
//       });
//       return;
//     }
//     setIsSubmitting(true);
//     try {
//       await addDiscourseType(discourse); // Use the state object directly
//       await new Promise((resolve) => setTimeout(resolve, 1000));

//       setOpenDialog(false);
//       setDiscourse({
//     discourseTypeName: "",
//     discourseTypeNameDz: "",
//       });
//       setAlert2("");

    
//       await fetchDiscourseTypes();
//       setAlert({
//         show: true,
//         severity: "success",
//         msg: "Discourse type added successfully",
//       });
//     } catch (error) {
//       await new Promise((resolve) => setTimeout(resolve, 1000));
//       setAlert2({
//         show: true,
//         severity: "error",
//         msg: `${error.message}`,
//       });
//     }
//     setIsSubmitting(false);
//   };

//   const handleUpdate = async () => {
//     setAlert({ ...alert, show: false });
//     setShowProgressIndicator(true);

//     try {
//       await updateDiscourse(rowsToUpdate);
//       await new Promise((resolve) => setTimeout(resolve, 1000));
//       setAlert({
//         show: true,
//         severity: "success",
//         msg: "Updated successfully",
//       });
//       setShowSaveBtn(false);
//     } catch (error) {
//       let msg = error.message || "Unknown error during update";

//       // Handle uniqueness error more clearly
//       if (msg.toLowerCase().includes("duplicate title")) {
//         msg = `Update failed: ${msg}`;
//       }

//       setAlert({
//         show: true,
//         severity: "error",
//         msg,
//       });
//     }
    
//     setShowProgressIndicator(false);
//   };

//   const handleDelete = async (params) => {
//     setShowProgressIndicator(true);
//     setAlert({ ...alert, show: false });

//     deleteDiscourseType(params.row).then(
//       async (response) => {
//         if (response instanceof AppwriteException) {
//           setAlert({
//             show: true,
//             severity: "error",
//             msg: response.response.message,
//           });
//         } else {
//           await new Promise((resolve) => setTimeout(resolve, 1000));
//           removeSingleRow(params.row);
//           setAlert({
//             show: true,
//             severity: "success",
//             msg: response.message
//             //"Discourse type deleted successfully",
//           });
//         }

//         setShowProgressIndicator(false);
//       },
//       (error) => {
//         setAlert({ show: true, severity: "error", msg: error });
//       }
//     );
//   };

//   const removeSingleRow = (params) => {
//     const newRows = rows.filter(
//       (row) => row.discourseTypeName !== params.discourseTypeName
//     );
//     setRows(newRows);
//   };

//   function onCellEditStop(params, event) {
//     if (event?.target?.value) {
//       const newRow = { ...params.row, [params.field]: event.target.value };
//       let exist = false;
//       let tmpRowsToUpdate = [...rowsToUpdate];
//       let count = 0;
//       // check if it exists in rowsToUpdate
//       for (let r of rowsToUpdate) {
//         if (params.id === r.$id) {
//           exist = true;
//           tmpRowsToUpdate[count] = newRow;
//           setRowsToUpdate(tmpRowsToUpdate);
//           setShowSaveBtn(true);
//           break;
//         }
//         count++;
//       }
//       // if doesn't exist then append to list
//       if (!exist) {
//         tmpRowsToUpdate.push(newRow);
//         setRowsToUpdate(tmpRowsToUpdate);
//         setShowSaveBtn(true);
//       }
//     }
//   }

//   function CustomLinearProgress() {
//     return (
//       <LinearProgress
//         style={{ backgroundColor: "white" }} // Change the background color to purple
//         color="secondary" // Change the color to secondary (the color you want)
//       />
//     );
//   }

//   useEffect(() => {
//     const result = areArraysEqual(rowsBackup.current, rows);
//     if (!result) {
//       setShowSaveBtn(true);
//     } else {
//       setShowSaveBtn(false);
//     }
//   }, [rows, rowsBackup]);

//   useEffect(() => {
//     fetchDiscourseTypes();
//   }, []);


//   return (
//     <Box p={3} width={"100%"}>
//       {/* alert */}
//       <CustomAlert alert={alert} setAlert={setAlert} />
//       <Box sx={{ display: "flex" }} gap={1}>
//         <Button
//           variant="outlined"
//           onClick={() => setOpenDialog(true)}
//           sx={{ boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)" }}
//         >
//           Add Discourse Type
//         </Button>

//         {/* Add Discourse form */}
//         <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
//           <DialogTitle>
//             <Typography align="center">
//               <strong>Discourse Type</strong>
//             </Typography>
//           </DialogTitle>
//           <DialogContent>
//             <Box sx={{ width: 500, maxWidth: "100%", ml: 1, mr: 1, mt: 1 }}>
//               <CustomAlert alert={alert2} setAlert={setAlert2} />
//             </Box>
//             <Box sx={{ width: 500, maxWidth: "100%", ml: 1, mr: 1 }}>
//               <TextField
//                 fullWidth
//                 label="English Title"
//                 name="discourseTypeName"
//                 value={discourse.discourseTypeName}
//                 onChange={handleChange}
//                 required
//                 id="discourseTypeName"
//               />
//             </Box>

//                     <Box sx={{ width: 500, maxWidth: "100%", ml: 1, mr: 1 , mt:1}}>
//               <TextField
//                 fullWidth
//                 label="Dzongkha Title"
//                 name="discourseTypeNameDz"
//                 value={discourse.discourseTypeNameDz}
//                 onChange={handleChange}
//                 required
//                 id="discourseTypeNameDz"
//               />
//             </Box>

        
//           </DialogContent>
//           <DialogActions>

//             <Button
//               variant="outlined"
//               sx={{ boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)", mb:1 }}
//               color="primary"
//               onClick={handleAddDiscourseType}
//               disabled={isSubmitting}
//             >
//               {isSubmitting ? "Submitting..." : "Submit"}
//             </Button>

//             <Button
//               variant="outlined"
//               color="error"
//               // style={{ color: "red" }}
//               sx={{ boxShadow: "0px 2px 4px rgba(250, 6, 6, 0.1)", mb:1, mr:1, }}
//               onClick={() => {
//                 setOpenDialog(false);
//                 setAlert2("");
//                 setDiscourse({
//                     discourseTypeName: "",
//                     discourseTypeNameDz: "",
//                 });
//               }}
//             >
//               Close
//             </Button>


//           </DialogActions>
//         </Dialog>

//         {showSaveBtn && rowsToUpdate.length > 0 && (
//           <Button
//             variant="outlined"
//             size="small"
//             onClick={handleUpdate}
//             sx={{ boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)" }}
//           >
//             Update
//           </Button>
//         )}
//       </Box>
//       <Typography sx={{ marginTop: 1, marginBottom: 1 }}>
//         Total: {rows.length}
//       </Typography>

//       {/* data grid */}
//       <Box
//         sx={{
//           height: "70vh",
//           width: "100%",
//           boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
//           "& .super-app-theme--header": {
//             backgroundColor: "#ebdcfa",
//           },
//         }}
//       >
//         <DataGrid
//           getRowId={(row) => row.$id}
//           rows={rows}
//           columns={columns}
//           loading={isLoadingData}
//           slots={{
//             loadingOverlay: CustomLinearProgress,
//           }}
//           onCellEditStop={onCellEditStop}
//         />
//       </Box>

//       {/* delete dialog */}
//       <Dialog
//         open={deleteDialogOpen}
//         onClose={() => setDeleteDialogOpen(false)}
//         aria-labelledby="confirm-delete-data"
//       >
//         <DialogTitle id="confirm-delete-data">Confirm Deletion</DialogTitle>
//         <DialogContent>
//           <DialogContentText>
//             Are you sure you want to delete the discourse type: "
//             <strong>{rowToDelete?.row?.discourseTypeName}</strong>" ? 
//             All the discourse data under this will also be deleted.
//           </DialogContentText>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setDeleteDialogOpen(false)} 
//             color="primary"
//             variant="outlined"
//             sx={{ boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)", mb:1 }}
//             >
//             Cancel
//           </Button>
//           <Button
//             onClick={() => {
//               setDeleteDialogOpen(false);
//               handleDelete(rowToDelete);
//             }}
//             variant="outlined"
//             sx={{ boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)", mb:1 }}
//             color="error"
//             autoFocus
//           >
//             Confirm
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* process indicator */}
//       <ProgressIndicator show={showProgressIndicator} />
//     </Box>
//   );
// };
// export default DiscourseType;